import React from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import SendIcon from '@material-ui/icons/Send';
import * as actions from '../actions/project';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Chip from '@material-ui/core/Chip';
import Modal from '@material-ui/core/Modal';
import {makeStyles} from '@material-ui/core/styles';


const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    form: {
        '& > *': {
            margin: theme.spacing(1),
            width: '100%',
        },
    },
    chart: {
      height: '600px',
      'background-image': 'url(/images/BlueNonCustemer.png)',
      'background-repeat': 'no-repeat',
    },
    gridcolumn: {
      'margin-top': '250px',
      'margin-left': '125px',
    },
    grid: {
    },
    Button: {
      background: 'linear-gradient(45deg, #1c7ff4 30%, #45adf7)'
    },
    buttonDelete: {
      float: 'right',
    },
    chip: {
      maxWidth: '600px',
      whiteSpace: 'pre-line',
      backgroundColor: 'white',
      borderRadius: '15px',
      padding: '15px',
      boxShadow: theme.shadows[1],
    }
}));


function Insights({selected,projectId,chartId,updateChart}) {
  const classes = useStyles();
  const [openUpdate, setOpenUpdate] = React.useState(false);
  const [keys, setKeys] = React.useState({
    key: null
  });
  const [values, setValues] = React.useState({
      title: '',
      insights: [],
  });

  const handleChange = name => event => {
      setValues({...values, [name]: event.target.value});
  };


  const handleClick = event => {

    if (selected.insights[0]===undefined) {

      const newData = []
      newData.push({
        'insights': values.insights,
      })
      setValues({data: newData});
      // console.log('insights log', selected.insights[0]===undefined, newData)
      updateChart(projectId, chartId, {...selected, insights: newData})

    } else {
      // console.log('insights log else')
      const newData = [...selected.insights];
      newData.push({
        'insights': values.insights,
      })
      setValues({data: newData});
      updateChart(projectId, chartId, {...selected, insights: newData})
    }

    setValues({'insights': ''});
  };


  const chipClickModal = (key) => {
    setOpenUpdate(true)
    setKeys({
      'key': key
    })

    // console.log(key)
  }

  const closeModal = () => {
    setValues({
      insights: undefined,
    })
    setOpenUpdate(false)
  }

  const chipClickDelete = event => {
    const newData = [...selected.insights]

    newData.splice(event,1)
    setValues({data: newData})
    updateChart(projectId, chartId, {...selected, insights: newData})
    setOpenUpdate(false)
    setValues({'insights': ''});

  }

  const handleClickUpdate = event => {

    const newData = {
      'insights': values.insights,
    }
    selected.insights[keys.key] = newData


    updateChart(projectId, chartId, {...selected, insights: selected.insights})
    setOpenUpdate(false)
    setValues({'insights': ''});
  }

  return (

      <>
      <h2>Insights</h2>
        <form>
          <TextField
              id="Insights"
              multiline
              value={values.insights}
              onChange={handleChange('insights')}
              />
          <Button
              onClick={handleClick}>
              <SendIcon
                color="primary"/>
          </Button>
        </form>

        {Object.values(selected.insights).map(
          (obj, key) =>
            <div
              key={key}>
                  <List component="nav" aria-label="main mailbox folders">
                    <div key={key}>
                      <ListItem
                        key={key}>
                        <div
                          key={key}
                          className={classes.chip}
                          component="p"
                          clickable
                          onClick={() => chipClickModal(key)}
                        >
                          {obj.insights}
                        </div>
                      </ListItem>
                    </div>
                  </List>

            </div>
        )}


        <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            className={classes.modal}
            open={openUpdate}
            onClose={() => closeModal()}
        >
        <div className={classes.paper}>
            {selected.insights[keys.key] && <>
              
              <form
                  className={classes.form}
                  noValidate autoComplete="off">
                  <TextField
                      id="insights"
                      multiline
                      defaultValue={selected.insights[keys.key].insights}
                      onChange={handleChange('insights')}/>
              </form>
              <br/>
              <Button
                  className={classes.Button}
                  variant="contained"
                  color="primary"
                  onClick={() => handleClickUpdate(keys.key)}>
                  Update
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                className={classes.buttonDelete}
                onClick={() => chipClickDelete(keys.key)}
              >
                  Delete
              </Button>
              </>}
            </div>
          </Modal>





      </>
  )
}

const mapStateToProps = state => state.charts;
const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch);

export default connect(
    mapStateToProps, mapDispatchToProps,
)(Insights)
